module.exports = __webpack_public_path__ + "static/media/icon.26804284.png";